// client/src/screens/admin/products/haberdashery/HaberdasheryFormStatus.js

import React, { memo } from "react";

const HaberdasheryFormStatus = memo(function HaberdasheryFormStatus({
  draftRestored = false,
  isEditing = false,
  submitDisabled = false,
  conflictMessage = "",
  error = "",
  submitError = "",
  onDiscardDraft,
}) {
  return (
    <>
      {draftRestored ? (
        <div className="admin-feedback admin-feedback--info admin-form-banner">
          <div>
            A saved draft was restored for this haberdashery product.
            {isEditing ? " Review changes before saving." : ""}
          </div>

          <button
            type="button"
            className="admin-btn admin-btn--secondary"
            onClick={onDiscardDraft}
            disabled={submitDisabled}
          >
            Discard draft
          </button>
        </div>
      ) : null}

      {conflictMessage ? (
        <div className="admin-feedback admin-feedback--error">
          {conflictMessage}
        </div>
      ) : null}

      {error && !conflictMessage ? (
        <div className="admin-feedback admin-feedback--error">{error}</div>
      ) : null}

      {submitError ? (
        <div className="admin-feedback admin-feedback--error">
          {submitError}
        </div>
      ) : null}
    </>
  );
});

export default HaberdasheryFormStatus;
